export const playCopy = {
  play_subnav_title: "Playground",
  play_subnav_config: "TS Config",
  play_config_language_blurb: "Quel langage doit être utilisé dans l'éditeur",
  play_subnav_handbook: "Aide",
  play_subnav_examples: "Exemples",
  play_subnav_examples_close: "Fermer",
  play_subnav_whatsnew: "Nouveautés",
  play_subnav_settings: "Paramètres",
  play_settings_tabs_settings: "Onglets de la barre latérale",
  play_downloading_typescript: "Téléchargement de TypeScript...", // when loading
  play_downloading_version: "Version...", // when loading
  play_toolbar_run: "Exécuter",
  play_toolbar_export: "Exporter",
  play_toolbar_share: "Partager",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "Erreurs",
  play_sidebar_errors_no_errors: "Pas d'erreurs",
  play_sidebar_logs: "Logs",
  play_sidebar_logs_no_logs: "Pas de logs",
  play_sidebar_options: "Options",
  play_sidebar_options_restart_required: "Besoin de recharger la page",
  play_sidebar_options_disable_ata: "Désactiver l'AAT",
  play_sidebar_options_disable_ata_copy:
    "Désactive l'acquisition automatique des types pour les imports et les requires.",
  play_sidebar_options_disable_save: "Désactiver la sauvegarde automatique",
  play_sidebar_options_disable_save_copy:
    "Désactive le changement de l'URL lorsque vous êtes en train de taper.",
  play_sidebar_plugins: "Plugins",
  play_sidebar_featured_plugins: "Plugins mis en avant",
  play_sidebar_plugins_options_external:
    "Plugins tiers <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>venant de npm</a>",
  play_sidebar_plugins_options_external_warning:
    "Attention : Le code des plugins provient de tiers.",
  play_sidebar_plugins_options_modules: "Modules npm personnalisés",
  play_sidebar_plugins_options_modules_placeholder: "Nom du module venant d'npm.",
  play_sidebar_plugins_plugin_dev: "Développement de plugins",
  play_sidebar_plugins_plugin_dev_option:
    "Connectez-vous sur <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "Essayer de se connecter automatiquement à un plugin du playground en mode de développement. Vous pouvez commencer à <a href='/dev/playground-plugins/' title='Lien vers la page sur les plugins du Playground'>créer un plugin ici</a>.",
  play_export_report_issue: "Signaler un problème sur GitHub concernant TypeScript",
  play_export_tweet_md: "Tweeter un lien vers ce Playground",
  play_export_copy_md: "Copier sous forme de problème Markdown",
  play_export_copy_link: "Copier sous forme de lien Markdown",
  play_export_copy_link_preview: "Copier sous forme de lien Markdown avec aperçu",
  play_export_tsast: "Ouvrir dans le lecteur d'AST TypeScript",
  play_export_bugworkbench: "Ouvrir dans Bug Workbench",
  play_export_vscode_dev_play: "Ouvrir dans le Playground TS de VSCode (alpha)",
  play_export_sandbox: "Ouvrir dans CodeSandbox",
  play_export_stackblitz: "Ouvrir dans StackBlitz",
  play_export_clipboard: "URL copiée dans le presse-papiers",
  play_esm_mode: "Passage en mode ESM",
  play_clear_logs: "Logs effacés",
  play_run_js: "JavaScript exécuté",
  play_run_ts: "TypeScript transpilé exécuté",
  play_run_js_fail: "Erreur lors de l'exécution du JavaScript :",
  play_default_code_sample: `// Bienvenue dans le Playground TypeScript, c'est un site web
// qui vous permet d'écrire, de partager et d'apprendre TypeScript.

// Vous pouvez voir cela de trois façons différentes :
//
// - Un endroit pour apprendre TypeScript où il n'y a rien à craindre
// - Un endroit pour explorer la syntaxe TypeScript et partager des URL avec les autres
// - Un bac à sable pour expérimenter les différentes fonctionnalités du compilateur TypeScript

const anExampleVariable = "Hello World"
console.log(anExampleVariable)

// Pour en savoir plus sur le langage, cliquez ci-dessus dans "Exemples" ou "Nouveautés".
// Sinon, commencez par supprimer ces commentaires et le monde sera votre terrain de jeu.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "Affiche le JS transpilé",

  play_sidebar_dts_title: "Fichiers de définition",
  play_sidebar_dts_blurb: "Montre le fichier .d.ts produit par votre code",

  play_sidebar_err_title: "Erreurs de compilation",
  play_sidebar_err_blurb: "Affiche les erreurs de compilation dans leur intégralité",

  play_sidebar_run_title: "Exécute le JavaScript dans le navigateur",
  play_sidebar_run_blurb:
    "Affiche le résultat de l'exécution du JavaScript dans l'éditeur",

  play_sidebar_plugins_title: "Gérer les plugins du Playground",
  play_sidebar_plugins_blurb:
    "Gère l'ajout/la suppression de plugins tiers dans le playground",

  play_sidebar_ast_title: "[WIP] Lecteur d'AST",
  play_sidebar_ast_blurb: "Inspecte l'AST TypeScript",

  play_sidebar_tools_filter_placeholder: "Filtre",
  // Notes:
  // Compiler flag information is all from the tsconfig reference info
}
